import type { ReactNode } from "react";
import { groupByRow } from "@/lib/layout";
import type { WidgetConfig } from "@/lib/schema";

interface Props {
  widgets: WidgetConfig[];
  renderWidget: (widget: WidgetConfig) => ReactNode;
}

export function WidgetRows({ widgets, renderWidget }: Props) {
  const rows = groupByRow(widgets);
  return (
    <div className="widget-grid">
      {rows.map((r) => (
        <div
          key={r.row}
          className="widget-row"
          data-testid={`widget-row-${r.row}`}
        >
          {r.widgets.map((w) => renderWidget(w))}
        </div>
      ))}
    </div>
  );
}
